import { useState } from 'react';
import { motion } from 'framer-motion';
import Breadcrumbs from '../components/Breadcrumbs';
import { Building2, Search, Plus, Phone, Mail, Globe, MoreHorizontal } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';

const mockClients = [
  { id: 'cl_001', name: 'Dharma Productions', type: 'Production House', contact: 'karan@dharma.in', phone: '+91 98765 43210', status: 'active', ainaa_id: 'AINAA-ORG-D8K2M' },
  { id: 'cl_002', name: 'YRF Studios', type: 'Studio', contact: 'booking@yrf.com', phone: '+91 98765 12345', status: 'active', ainaa_id: 'AINAA-ORG-Y5W9L' },
  { id: 'cl_003', name: 'Excel Entertainment', type: 'Production House', contact: 'ops@excelentr.com', phone: '+91 99876 54321', status: 'active', ainaa_id: 'AINAA-ORG-E7R4X' },
  { id: 'cl_004', name: 'Candid Studios', type: 'Photography', contact: 'info@candidstudios.in', phone: '+91 88765 43210', status: 'inactive', ainaa_id: 'AINAA-ORG-C3P8Q' },
  { id: 'cl_005', name: 'Phantom Films', type: 'Production House', contact: 'hello@phantom.film', phone: '+91 77654 32100', status: 'active', ainaa_id: 'AINAA-ORG-P9N2F' },
  { id: 'cl_006', name: 'Saregama', type: 'Music Label', contact: 'sync@saregama.com', phone: '+91 66543 21098', status: 'active', ainaa_id: 'AINAA-ORG-S4L7J' },
];

export default function ClientsPage() {
  const [search, setSearch] = useState('');
  const filtered = mockClients.filter(c =>
    !search || c.name.toLowerCase().includes(search.toLowerCase()) || c.type.toLowerCase().includes(search.toLowerCase()) || c.ainaa_id.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
      <Breadcrumbs />
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <Building2 className="w-5 h-5 text-foreground" strokeWidth={1.5} />
          <div>
            <h1 className="text-2xl font-semibold tracking-tight font-heading">Clients</h1>
            <p className="text-xs text-muted-foreground mt-0.5">Non-film work clients and vendors</p>
          </div>
        </div>
        <Button size="sm" className="gap-1.5 h-8 text-xs" data-testid="add-client-btn">
          <Plus className="w-3.5 h-3.5" strokeWidth={1.5} /> Add Client
        </Button>
      </div>

      <div className="relative mb-6">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" strokeWidth={1.5} />
        <Input
          placeholder="Search by name, type, or AINAA ID..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="pl-9 h-9 text-sm"
          data-testid="clients-search"
        />
      </div>

      <div className="space-y-1">
        {filtered.map(c => (
          <div
            key={c.id}
            className="flex items-center gap-4 px-4 py-3.5 rounded-lg border border-transparent hover:border-border/50 hover:bg-secondary/40 transition-all group cursor-pointer"
            data-testid={`client-${c.id}`}
          >
            <div className="w-9 h-9 rounded-lg bg-secondary flex items-center justify-center flex-shrink-0">
              <Building2 className="w-4 h-4 text-muted-foreground" strokeWidth={1.5} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <p className="text-sm font-medium truncate">{c.name}</p>
                <Badge variant={c.status === 'active' ? 'secondary' : 'outline'} className="text-[10px] h-4 px-1.5">{c.status}</Badge>
              </div>
              <div className="flex items-center gap-3 mt-0.5">
                <span className="text-[10px] text-muted-foreground">{c.type}</span>
                <span className="text-[10px] font-mono text-muted-foreground/60">{c.ainaa_id}</span>
              </div>
            </div>
            <div className="flex items-center gap-3 text-muted-foreground/60 opacity-0 group-hover:opacity-100 transition-opacity">
              <a href={`mailto:${c.contact}`} className="hover:text-foreground" data-testid={`client-email-${c.id}`}><Mail className="w-3.5 h-3.5" strokeWidth={1.5} /></a>
              <a href={`tel:${c.phone}`} className="hover:text-foreground"><Phone className="w-3.5 h-3.5" strokeWidth={1.5} /></a>
              <button className="hover:text-foreground"><MoreHorizontal className="w-3.5 h-3.5" strokeWidth={1.5} /></button>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
